module.exports = __webpack_public_path__ + "img/success@2x.e6070dc2.png";